export default {
  merchantServiceOfferings: [],
};
